import React from 'react';
import LogInForm from './components/ResetPassword';
import './login.css';
import jarvisIcon from '../../../images/Jarvis.svg';
import jarvisLogo from '../../../images/Jarvis_logo.svg';

const ResetPassword = () => {
  return (
    <div className="account" style={styles.container}>
      <div className="account_wrapper" style={styles.wrapper}>
        <div className="account_card" id="login_right_card" style={styles.card}>
          <div className="account_head" style={styles.header}>
            <img src={jarvisIcon} alt="Jarvis Icon" style={styles.logoIcon} />
            <img src={jarvisLogo} alt="Jarvis Logo" style={styles.logoText} />
          </div>

          <h3 style={styles.title}>Reset Password</h3>

          <LogInForm onSubmit />

          <div style={styles.notes}>
            <p style={styles.noteTitle}>Note:</p>
            <ul style={styles.noteList}>
              <li>Password length must be greater than 9 characters.</li>
              <li>Must not contain your first name, last name, or email.</li>
              <li>Must include an uppercase letter, lowercase letter, and a number.</li>
              <li>Must include at least one special character.</li>
              <li>Should not contain sequential characters or numbers.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#fef1cc',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px 20px',
    minHeight: '100vh',
  },
  wrapper: {
    width: '100%',
    maxWidth: '450px',
    textAlign: 'center',
    
  },
  card: {
    width: '100%',
    backgroundColor: 'white',
    borderRadius: '2px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    padding: '30px',
    paddingTop: '0px',
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '20px'
    
  },
  logoIcon: {
    width: '20%',
    maxWidth: '80px',
  },
  logoText: {
    width: '5%',
    marginLeft: '10px',
  },
  title: {
    fontWeight: 'bold',
    color: 'rgba(2, 2, 2, 0.7)',
    marginBottom: '20px',
  },
  notes: {
    textAlign: 'left',
    marginTop: '5px',
    marginLeft: '25px',
    marginRight: '30px',
    paddingBottom:'10px'
  },
  noteTitle: {
    fontWeight: 'bold',
    marginBottom: '8px',
  },
  noteList: {
    paddingLeft: '18px',
    fontSize: '0.95rem',
    color: '#444',
    lineHeight: '1.5',
  },
};

export default ResetPassword;
